import React, { useState } from 'react';
import { Button, Form, Table } from "react-bootstrap";
import DashboardLayout from "../../DashboardLayout";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function FallbackPerformance() {
  const allData = [
    { network: "Google AdMob", fillRate: 95, eCPM: 1.2 },
    { network: "Facebook", fillRate: 90, eCPM: 1.1 },
    { network: "Unity Ads", fillRate: 85, eCPM: 1.0 },
  ];

  const [selectedNetwork, setSelectedNetwork] = useState("");

  const handleReset = () => setSelectedNetwork("");

  const filteredData = selectedNetwork
    ? allData.filter(
        (item) =>
          item.network.toLowerCase().replace(/\s+/g, "-") ===
          selectedNetwork
      )
    : allData;

  const chartData = {
    labels: filteredData.map((item) => item.network),
    datasets: [
      {
        label: "eCPM ($)",
        data: filteredData.map((item) => item.eCPM),
        backgroundColor: "rgba(255, 99, 132, 0.7)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { labels: { color: "#fff" } },
    },
    scales: {
      x: { ticks: { color: "#fff" } },
      y: { beginAtZero: true, ticks: { color: "#fff" } },
    },
  };

  return (
    <DashboardLayout>
      {/* Filter Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by Ad Network</h5>
          <div className="row align-items-center">
            <div className="col-md-3 mb-2">
              <Form.Select
                className="bg-dark text-light border-light"
                value={selectedNetwork}
                onChange={(e) => setSelectedNetwork(e.target.value)}
              >
                <option value="">All ad networks</option>
                <option value="google-admob">Google AdMob</option>
                <option value="facebook">Facebook</option>
                <option value="unity-ads">Unity Ads</option>
              </Form.Select>
            </div>
            <div className="col-md-2 mb-2">
              <Button className="btn btn-success" onClick={handleReset}>
                Reset
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">
            Fallback Performance
          </h5>
          <p className="card-text">
            If using waterfall mediation, track which networks deliver the best fill rates & eCPM.
          </p>
          <div className="table-responsive">
            <Table className="table-hover table-striped align-middle table-borderless table-dark mb-0">
              <thead>
                <tr>
                  <th>Ad Network</th>
                  <th>Fill Rate (%)</th>
                  <th>eCPM ($)</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.network}</td>
                    <td>{item.fillRate}%</td>
                    <td>${item.eCPM.toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {filteredData.length === 0 && (
              <p className="text-muted mt-3">No data available.</p>
            )}
          </div>
        </div>
      </div>

      {/* Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">eCPM by Ad Network</h6>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default FallbackPerformance;